export const api = {
  baseUrl: '/api/v1',
};

export const masp_pdv_api = {
  baseUrl: 'http://localhost:3500/api',
};

export const awsExports = {
  aws_project_region: process.env.NEXT_PUBLIC_PROJECT_REGION as string,
  aws_cognito_identity_pool_id: process.env.NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID as string,
  aws_cognito_region: process.env.NEXT_PUBLIC_COGNITO_REGION as string,
  aws_user_pools_id: process.env.NEXT_PUBLIC_USER_POOLS_ID as string,
  aws_user_pools_web_client_id: process.env.NEXT_PUBLIC_USER_POOLS_WEB_CLIENT_ID as string,
  oauth: {
    domain: process.env.NEXT_PUBLIC_OAUTH_DOMAIN as string,
    scopes: process.env.NEXT_PUBLIC_OAUTH_SCOPE?.split(',') as string[],
    redirectSignIn: process.env.NEXT_PUBLIC_OAUTH_REDIRECTSIGNIN?.split(',') as string[],
    redirectSignOut: process.env.NEXT_PUBLIC_OAUTH_REDIRECTSIGNOUT?.split(',') as string[],
    responseType: process.env.NEXT_PUBLIC_OAUTH_RESPONSETYPE as 'code' | 'token',
  },
  federationTarget: process.env.NEXT_PUBLIC_FEDERATIONTARGET as string,
  aws_cognito_username_attributes: process.env.NEXT_PUBLIC_COGNITO_USERNAME_ATTRIBUTES?.split(',') as string[],
  aws_cognito_social_providers: process.env.NEXT_PUBLIC_COGNITO_SOCIAL_PROVIDERS?.split(',') as string[],
  aws_cognito_signup_attributes: process.env.NEXT_PUBLIC_COGNITO_SIGNUP_ATTRIBUTES?.split(',') as string[],
  aws_cognito_mfa_configuration: process.env.NEXT_PUBLIC_COGNITO_MFA_CONFIGURATION as string,
  aws_cognito_mfa_types: process.env.NEXT_PUBLIC_COGNITO_MFA_TYPES?.split(',') as string[],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: Number(
      process.env.NEXT_PUBLIC_COGNITO_PASSWORD_PROTECTION_SETTINGS_PASSWORDPOLICYMINLENGTH
    ) as number,
    passwordPolicyCharacters:
      process.env.NEXT_PUBLIC_COGNITO_PASSWORD_PROTECTION_SETTINGS_PASSWORDPOLICYCHARACTERS?.split(',') as string[],
  },
  aws_cognito_verification_mechanisms: process.env.NEXT_PUBLIC_COGNITO_VERIFICATION_MECHANISMS?.split(',') as string[],
  aws_cloud_logic_custom: [
    {
      name: process.env.NEXT_PUBLIC_AWS_CLOUD_LOGIC_CUSTOM_NAME as string,
      endpoint: process.env.NEXT_PUBLIC_AWS_CLOUD_LOGIC_CUSTOM_ENDPOINT as string,
      region: process.env.NEXT_PUBLIC_AWS_CLOUD_LOGIC_CUSTOM_REGION as string,
    },
  ],
};

// AWS AppConfig deprecated - using LaunchDarkly for feature flags
// SECURITY: AWS credentials should NEVER be exposed in NEXT_PUBLIC_ variables
